// src/config/version.js
//
// Single source of truth for the app version displayed throughout the UI
// (e.g. Company Settings page, Login page footer).
//
// The version number itself is NOT hardcoded here - it is read directly
// from package.json, which already follows standard npm/semver conventions.
//
// To release a new version, simply bump the "version" field in
// package.json (manually, or via `npm version patch` / `minor` / `major`).
// This file picks up the change automatically - no other file needs
// to be touched.

import packageJson from '../../package.json';

export const APP_VERSION = packageJson.version;